import { Image } from 'api/contentful/contentTypes.cloverdotcom';
import { FlatResponsiveImage } from 'components/FlatResponsiveImage/FlatResponsiveImage';
import React, { FC, HTMLAttributes, ImgHTMLAttributes } from 'react';
import { FlatEntry } from 'services/cms/flattenContentful';

export type SubjectImageProps = ImgHTMLAttributes<HTMLImageElement> & {
  entry?: FlatEntry<Image>;
  isLazyLoad?: boolean;
  pictureProps?: HTMLAttributes<HTMLElement>;
};

export const SubjectImage: FC<SubjectImageProps> = ({
  entry,

  style: { objectFit, objectPosition, ...style } = {},
  ...props
}) => {
  if (!entry) return null;
  const { image, imageFit, imagePosition, mobileImage, tabletImage } = entry;
  return (
    <FlatResponsiveImage
      image={image}
      mobileImage={mobileImage}
      tabletImage={tabletImage}
      style={{ ...style, objectFit: objectFit ?? imageFit, objectPosition: objectPosition ?? imagePosition }}
      {...props}
    />
  );
};
